module.exports = __webpack_public_path__ + "static/img/help.48e5c03b.svg";